import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles.css';
import { useUsers } from "../contexts/UsersContext";

export default function Users({ apiUrl, isAdmin }) {
  const [imports, setImports] = useState([]);
  const { users, setUsers } = useUsers();

  useEffect(() => {
    if (isAdmin) {
      fetchImports();
    }
  }, [isAdmin]);


  const fetchImports = () => {
    const fullImportsUrl = `${apiUrl}/list-users`;
    axios
      .get(fullImportsUrl, { withCredentials: true })
      .then((response) => {
        console.log('Received imports list:', response.data);
        setImports(response.data);
      })
      .catch((error) => {
        console.log('Error fetching users:', error);
        setUsers([]);
      });
  };

  const handleCreateUser = (userSub, userName) => {
    const createUrl = `${apiUrl}/users`;
    const newUser = { sub: userSub, name: userName };

    axios
      .post(createUrl, newUser, { withCredentials: true })
      .then((response) => {
        console.log(`User with sub ${userSub} created successfully.`);
        setUsers((prevUsers) => [...prevUsers, response.data]);
      })
      .catch((error) => {
        console.error(`Error creating user with sub ${userSub}:`, error);
        alert('Failed to create the user. Please try again.');
      });
  };

  const handleDeleteUser = (userId) => {
    const confirmDelete = window.confirm(
      'Are you sure you want to delete this user?'
    );
    if (!confirmDelete) {
      return;
    }

    const deleteUrl = `${apiUrl}/users/${userId}`;
    axios
      .delete(deleteUrl, { withCredentials: true })
      .then(() => {
        console.log(`User with ID ${userId} deleted successfully.`);
        setUsers(users.filter((user) => user.id !== userId));
      })
      .catch((error) => {
        console.error(`Error deleting user with ID ${userId}:`, error);
        alert('Failed to delete the user. Please try again.');
      });
  };

  return isAdmin ? (
    <div className="users-container">
      <div
        id="importTable"
        style={{ display: imports.length === 0 ? 'none' : '' }}
      >
        <table className="custom-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Sub</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {imports.map((imp) => (
              <tr key={imp.sub}>
                <td>{imp.name}</td>
                <td>{imp.sub}</td>
                <td>
                  <button
                    className="action-button"
                    onClick={() => handleCreateUser(imp.sub, imp.name)}
                  >
                    Add as User
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ display: imports.length === 0 ? '' : 'none' }}>
        <p>There are no importable users.</p>
      </div>
      <br />
      <div
        id="userTable"
        style={{ display: users.length === 0 ? 'none' : '' }}
      >
        <table className="custom-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Sub</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.name}</td>
                <td>{user.sub}</td>
                <td>
                  <button
                    className="action-button"
                    onClick={() => handleDeleteUser(user.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ display: users.length === 0 ? '' : 'none' }}>
        <p>
          There are no users. Use the form above to import user data, if
          applicable.
        </p>
      </div>
    </div>
  ) : (
    ''
  );
}
